// /admin/chats/$id — real route. Mirrors apps/web's
// app/admin/chats/[id]/page.tsx: 'use client' page that reads its own `id`
// via next/navigation's useParams() (shimmed onto TanStack params in
// next-compat/navigation.tsx), so it's lazy-imported directly per the
// porting convention (route-helpers.tsx) — no wrapper needed to thread the
// param through. Renders the same GenUIChat surface read-only in admin mode
// (readOnly + adminView props on the original ChatView import). Registered
// from routes/admin.tsx under the `_admin` guard (routes/guards.tsx),
// parity with app/admin/layout.tsx:6.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './guards';

const AdminChatDetailPage = lazy(() => import('@/app/admin/chats/[id]/page'));

export const adminChatDetailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/admin/chats/$id',
  component: AdminChatDetailPage,
});
